import { render, staticRenderFns } from "./AddAdditionalWork.vue?vue&type=template&id=99eb5ae0&scoped=true"
import script from "./AddAdditionalWork.vue?vue&type=script&lang=js"
export * from "./AddAdditionalWork.vue?vue&type=script&lang=js"
import style0 from "./AddAdditionalWork.vue?vue&type=style&index=0&id=99eb5ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99eb5ae0",
  null
  
)

export default component.exports